import styled from 'styled-components';

interface LoadingProps {
	$loading: boolean;
}

export const Loading = styled.div`
	position: absolute;
	inset: 0;
	width: 100%;
	height: 100%;
	/* background: var(--ion-color-primary); */
	animation: fade 1s alternate infinite ease-in-out;
	z-index: 1;
	transition: opacity 0.3s;
	opacity: ${(props: LoadingProps) => (props.$loading ? 1 : 0)};
`;

export const ImageContainer = styled.div`
	width: 100%;
	height: 100%;
	position: absolute;
	isolation: isolate;
`;

export const TestImage = styled.img`
	width: 100%;
	height: 100%;
	object-fit: cover;
	object-position: center center;
	position: absolute;
	inset: 0;
	opacity: ${(props: LoadingProps) => (props.$loading ? 0 : 1)};
`;
